define(function(require, exports, module) {
    'use strict';
    var UserModel = require('modules/user/user.model');

    module.exports = new UserModel();
});
